// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"24bd40bc","703":"c4ce4a0c"}[chunkId] + ".chunk.js";
};